export default __webpack_public_path__ + "static/media/6E.b3964e65.gif";